import { ICooperationPartner } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { CooperationPartnerWorkItem } from 'src/app/business/institution/cooperation-partner-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class CooperationPartnerCommandHandler extends EntityCommandHandler<ICooperationPartner> {
  protected workItem: IWorkItem<ICooperationPartner>;

  constructor(cooperationPartnerWorkItem: CooperationPartnerWorkItem) {
    super();
    this.workItem = cooperationPartnerWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'CooperationPartnerDto';
  }
}
